import { type FetchSocialFeedByFeedSlugAndChilizIdParams, useLocale } from '@capsicum/common';
import { userFeedKeys } from '@capsicum/socios-core';

import { useSocialFeedQuery } from '../data-access';
import { clearFeedPages, prepareFeedData } from '../util';

export const useUserFeed = (userId?: string) => {
	const { locale } = useLocale();
	const key = userFeedKeys.user(userId || '');
	const params: FetchSocialFeedByFeedSlugAndChilizIdParams = {
		chilizId: userId || '',
		feedSlug: 'fan_profile',
		limit: 10,
		locale: locale
	};

	const {
		data,
		error,
		fetchNextPage,
		hasNextPage,
		isFetched,
		isFetching,
		isLoading,
		refetch: refetchQuery
	} = useSocialFeedQuery(key, params);

	const { feedData, metadata } = prepareFeedData(data);

	const refetch = async () => {
		clearFeedPages(key);
		await refetchQuery();
	};

	return {
		data: feedData,
		error,
		fetchNextPage,
		hasNextPage,
		isFetched,
		isFetching,
		isLoading,
		metadata,
		refetch
	};
};
